document.addEventListener("DOMContentLoaded", () => {
    (() => {
  const root = document.currentScript?.previousElementSibling?.previousElementSibling?.previousElementSibling
    || document.querySelector('[data-v-return]');
  if (!root) return;

  const btn = root.querySelector('.v-return__toggle');
  const pop = root.querySelector('.v-return__popup');
  const closeBtn = root.querySelector('.v-return__close');

  const alignCheck = () => {
    const rect = root.getBoundingClientRect();
    if (rect.left < 24) root.removeAttribute('data-right-align');
    else if (window.innerWidth - rect.right < 280) root.setAttribute('data-right-align','');
    else root.removeAttribute('data-right-align');
  };
  alignCheck(); window.addEventListener('resize', alignCheck);

  const open = () => { pop.hidden = false; btn.setAttribute('aria-expanded','true'); };
  const close = () => { pop.hidden = true; btn.setAttribute('aria-expanded','false'); };
  const toggle = () => (pop.hidden ? open() : close());

  btn.addEventListener('click', toggle);
  closeBtn.addEventListener('click', close);

  // Click ra ngoài để đóng
  document.addEventListener('click', (e) => {
    if (pop.hidden) return;
    if (!root.contains(e.target)) close();
  });
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  }, { passive: true });
})();
})